import {
         PENDING_SUBMIT_LISTING_DISABLE,
         COMPLETE_SUBMIT_LISTING_DISABLE,
         FAILED_SUBMIT_LISTING_DISABLE
    } from "./mlTypes"


const initialState = {
    pendingsubmit: false,
    failedsubmit: false,
    completesubmit: false
}


const mlListingDisable = (state = initialState, action) => {
    switch (action.type) {

        case PENDING_SUBMIT_LISTING_DISABLE: return {
            ...state,
            pendingsubmit: true,
            failedsubmit: false,
            completesubmit: false
        }

        case COMPLETE_SUBMIT_LISTING_DISABLE: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: false,
            completesubmit: true
        }
        
        case FAILED_SUBMIT_LISTING_DISABLE: return {
            ...state,
            pendingsubmit: false,
            failedsubmit: true,
            completesubmit: true
        }
    
        default: return state
    }
}

export default mlListingDisable